import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ViHeaderDomainModule } from '@vi-succ/vi-header-domain';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { AuthService } from './app/shared/services/auth.service';
import { ApiInterceptor } from './app/shared/interceptors';
import { ApiModule } from '@nx-customer-apps/api-planning-projects';
import { domainTransitionFactory, DomainTransitionService } from '@nx-customer-apps/shared/services';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';

function HttpLoaderFactory(http: HttpBackend) {
    return new MultiTranslateHttpLoader(http, [
        {
            prefix: `${environment.translationsBaseUrl}/phraseapp-proxy/projects/${environment.phraseappProjectId.homePlanner}/locales/`,
            suffix: '/download?file_format=simple_json'
        },
        {
            prefix: `${environment.translationsBaseUrl}/phraseapp-proxy/projects/${environment.phraseappProjectId.flows}/locales/`,
            suffix: '/download?file_format=simple_json'
        },
        {
            prefix: `${environment.translationsBaseUrl}/phraseapp-proxy/projects/${environment.phraseappProjectId.globalHeader}/locales/`,
            suffix: '/download?file_format=simple_json'
        },
        {
            prefix: `${environment.translationsBaseUrl}/phraseapp-proxy/projects/${environment.phraseappProjectId.designSystemWeb}/locales/`,
            suffix: '/download?file_format=simple_json'
        }
    ]);
}

export function authAppInitializerFactory(authService: AuthService): () => Promise<void> {
    return () => authService.runInitialLoginSequence();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(appRoutes),
        importProvidersFrom(OAuthModule.forRoot()),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync(),
        importProvidersFrom(
            ViHeaderDomainModule.forRoot({
                baseUrl: `${environment.baseUrl}`,
                accountAppUrl: `${environment.accountAppUrl}`,
                partnerPortalBaseUrl: `${environment.partnerPortalBaseUrl}`
            }),
            ApiModule.forRoot({ rootUrl: environment.baseApiUrl })
        ),
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpBackend]
                }
            })
        ),
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: authAppInitializerFactory,
        //     multi: true,
        //     deps: [AuthService]
        // },
        {
            provide: APP_INITIALIZER,
            useFactory: domainTransitionFactory,
            deps: [DomainTransitionService],
            multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
        {
            provide: MAT_RIPPLE_GLOBAL_OPTIONS,
            useValue: { disabled: true }
        }
    ]
}).catch(err => console.error(err));
